module.exports = __webpack_public_path__ + "static/media/dumbbell.da8aa4bf.svg";